/**
  * This script is a hack to fix an issue with Flickity on inintial load that results in 
  * the slider not being able to calculate the correct height until the window is resized.
  * This script will fire the resize event on the window object in intervals for a set
  * amount of time to force the slider to calculate the correct height.
  */


((time, interval) => {
  const startTime = new Date().getTime();
  console.log('Flickity fix script running');
  const intervalId = setInterval(() => {
    window.dispatchEvent(new Event('resize'));
    if (new Date().getTime() - startTime > time) {
      clearInterval(intervalId);
      console.log('Flickity fix script stopped');
    }
  }, interval);
})(5000, 1000);

